import { IMacroExam } from 'features/cost-analysis/macro-exams/types';
import { BaseService } from 'shared/services/BaseService';

class MacroExamService extends BaseService<IMacroExam> {
  constructor() {
    super('macro-exams');
  }
  canDelete = true;
}

export const macroExamService = new MacroExamService();
